<div class="counter">
  <button class="counter__button" (click)="onRemove()" [disabled]="viewValue <= min || isDisabled">
    <mat-icon>remove</mat-icon>
  </button>

  <div class="counter__view">{{ viewValue }}</div>

  <button class="counter__button" (click)="onAdd()" [disabled]="isDisabled || viewValue >= max || isLockAdd">
    <mat-icon>add</mat-icon>
  </button>
</div>
